/*************************************************************************
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import PropTypes from "prop-types";
import { getDevicePixelRatio } from "dc-preview-utils/src/Utils/DeviceUtils";
import TileCanvasCss from "./TileCanvas.css";

class TileCanvas extends Component {
  constructor(props) {
    super(props);
    this.tileCanvasRef = null;
  }

  componentDidMount() {
    const dpi = getDevicePixelRatio();
    this.tileCanvasRef.width = this.props.width * dpi;
    this.tileCanvasRef.height = this.props.height * dpi;
    this.props.setTileCanvasRef(this.tileCanvasRef);
  }

  componentDidUpdate() {
    const dpi = getDevicePixelRatio();
    this.tileCanvasRef.width = this.props.width * dpi;
    this.tileCanvasRef.height = this.props.height * dpi;
  }

  render() {
    return (
      <div className={TileCanvasCss.tileCanvasParent}>
        <canvas
          data-testid="tileCanvas"
          className={TileCanvasCss.tileCanvas}
          ref={handle => {
            this.tileCanvasRef = handle;
          }}
        />
      </div>
    );
  }
}

TileCanvas.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  setTileCanvasRef: PropTypes.func.isRequired
};

export default TileCanvas;
